<template>
  <div>
  <div class="c-app-new flex-row align-items-center d-sm-down-none">
    <CRow class="p-0">
  <CCol sm="3" class="p-0">
 <TheSidebar></TheSidebar></CCol>
  <CCol sm="6" class="p-0">
       
    <CCarousel
        arrows
        indicators
        animate
        height="100px"
        class="mb-5"
        >
        <CCarouselItem>
          <span class="class-top-header top-header-badge">Best Match Quiz</span>
          <span class="class-top-header class-teach-name">Algebra and Calculus</span> 
          <span class="class-top-header class-teach-subject">Mathematics (Form 5)</span>
          <span class="float-right custom-bg-icon">
            <img src="../../assets/img/icon/Circle.svg" style="
            right: -6px;
            position: absolute;
            bottom: -135px;
            width: 160px;
            height: 160px;" />
            <img src="../../assets/img/icon/iconCalculator.svg" style="
            position: absolute;
            width: 70px;
            height: 70px;
            right: 20px;
            bottom: -95px;" />
          </span>
        </CCarouselItem>

        <CCarouselItem>
          <span class="class-top-header top-header-badge" style="width: 154px">Top Student of 5 Akas</span>
          <span class="class-top-header class-teach-name" style="width: 200px;">{{user.name}}</span> 
          <span class="class-top-header class-teach-subject">Mid Year Exam 2022 Mathematics</span>
          <span class="float-right custom-bg-icon">
            <img src="../../assets/img/icon/Circle.svg" style="
            right: -6px;
            position: absolute;
            bottom: -135px;
            width: 160px;
            height: 160px;" />
            <img src="../../assets/img/icon/userprofile.svg" style="
            position: absolute;
            width: 70px;
            height: 70px;
            right: 20px;
            bottom: -95px;" />
          </span>
        </CCarouselItem>
      </CCarousel>
      <br /> <br /> <br /> <br /> <br /> <br /> <br />
    <CContainer style="display: flex; justify-content: center;margin-top:0px" class="p-0">
      <div class="container-box-custom center">

        <div class="text-left">
          <div class="card-custom-web-new">
            <br /> 
            <CCard class="card-dark-orange mt-2">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3 class="label-dark-orange">
                    Your next class is at 9.00AM (Mathematics)
                  </h3>
                </div>
                <div style="width: 50%" class="float-right">
                  <img style="
                    position: absolute;
                    left: 73.13%;
                    right: 5.07%;
                    top: 3.57%;
                    bottom: 9.52%;"
                    src="../../assets/img/icon/bullseye.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <br />

            <div class="float-left">
              <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name"> Myself / My Child </strong>
            </div>

            <br /><br />
            
            <!-- <div class="class-card-multiple" >
              <CCard class="card-rectangle" @click="GoToTimetable()" style="width: 25%; order: 0;">
                <img src="../../assets/img/icon/iconTimetable.svg" class="icon-reactangle" style="
                  width: 51px;
                  height: 43px;
                  left: calc(50% - 51px/2);
                  top: calc(50% - 43px/2 + 3px);" />
              </CCard>

              <CCard class="card-rectangle" style="width: 25%; order: 1;" @click="GoToQuiz()">
                <img src="../../assets/img/icon/iconQuiz.svg" class="icon-reactangle" style="
                  width: 23px;
                  height: 39px;
                  left: calc(50% - 23px/2 + 0.5px);
                  top: calc(50% - 39px/2 + 5px);" />
              </CCard>

              <CCard class="card-rectangle" style="width: 25%; order: 2;">
                <img src="../../assets/img/icon/iconExam.svg" class="icon-reactangle" style="
                  width: 29px;
                  height: 39px;
                  left: calc(50% - 29px/2 + 0.5px);
                  top: calc(50% - 39px/2 + 5px);" />
              </CCard>

              <CCard class=" card-rectangle" style="width: 25%; order: 3;">
                <img src="../../assets/img/icon/iconAskkiddo.svg" class="icon-reactangle" style="
                  justify-content: center; 
                  width: 41px;
                  height: 39px;
                  left: calc(50% - 41px/2 + 0.5px);
                  top: calc(50% - 39px/2 + 5px);" />
              </CCard>
            </div> -->

            <CRow class="justify-content-center mb-2">
              <CCol
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol sm="12" lg="12">
                  <CCol
                    sm="12"
                    lg="12"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      left: 0;
                      right: 0;
                      bottom: 0px;
                    "
                  >
                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToTimetable()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/calendar.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Timetable</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToQuiz()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/quiz.svg" />
                          <br />
                          <label class="text-icon custom-font-cards"> Quiz</label>
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/exam.svg" style="filter: grayscale(1);"/>
                          <br />
                          <label class="text-icon custom-font-cards">
                            Exam</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" >
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/chat.svg" style="filter: grayscale(1);"/>
                          <br />
                          <label class="text-icon custom-font-cards">
                            Askkiddo</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>
                  </CCol>
                </CCol>
              </CCol>
            </CRow>


            <br />
              <div class="float-left">
                <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name"> Upcoming Class</strong>
              </div>
              <div class="float-right">
                <strong class="custom-text-viewall" style="margin: 20px;" @click="GoToTimetable()">View All</strong>
              </div>
              <div style="clear: both"></div>
          
              <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="2"
                pagination="yes"
                class="d-sm-down-none"
              >
                <slide
                  v-for="slide in schedule"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3"
                  >
                    <CCardHeader>
                      <b>{{ slide.name }} Class</b>
                      <div class="card-header-actions">
                        <b> Today</b>
                      </div>
                    </CCardHeader>
                    <CCardBody class="overflow-auto" v-if="slide.studentSchedule.length">
                      <div v-if="slide.studentSchedule.length">
                        <CRow
                          v-for="slides in slide.studentSchedule"
                          v-bind:key="slides.id" class="ml-2 mr-2"
                        >
                          <div style="width: 50%" class="float-left">
                            {{ slides.subjectName }}
                          </div>
                          <div style="width: 50%" class="float-right">
                            {{ slides.start | moment("HH:mm A") }} -
                            {{ slides.end | moment("HH:mm A") }}
                          </div>
                        </CRow>
                      </div>
                      <div v-else>
                        <CRow>
                          <div
                            style="
                              text-align: center;
                              margin: 0 auto;
                              left: 0;
                              right: 0;
                              width: fit-content;
                            "
                          >
                            No upcoming class
                          </div>
                        </CRow>
                      </div>
                    </CCardBody>
                     <CCardBody class="overflow-auto" v-else>
                       <div>
                        <CRow>
                          <div
                            style="
                              text-align: center;
                              margin: 0 auto;
                              left: 0;
                              right: 0;
                              width: fit-content;
                            "
                          >
                            No upcoming class
                          </div>
                        </CRow>
                      </div>
                    </CCardBody>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>

            <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="1"
                pagination="yes"
                class="d-sm-flex d-md-none"
              >
                <slide
                  v-for="slide in schedule"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 200px"
                    class="overflow-auto"
                  >
                    <CCardHeader>
                      <b>{{ slide.name }} Class</b>
                      <div class="card-header-actions">
                        <b> Today</b>
                      </div>
                    </CCardHeader>
                    <CCardBody class="overflow-auto" v-if="slide.studentSchedule.length">
                      <div>
                        <CRow
                          v-for="slides in slide.studentSchedule"
                          v-bind:key="slides.id"
                          class="ml-2 mr-2"
                        >
                          <div style="width: 50%" class="float-left">
                            {{ slides.subjectName }}
                          </div>
                          <div style="width: 50%" class="float-right">
                            {{ slides.start | moment("HH:mm A") }} -
                            {{ slides.end | moment("HH:mm A") }}
                          </div>
                        </CRow>
                      </div>
                     
                    </CCardBody>
                    <CCardBody class="overflow-auto" v-else>
                       <div>
                        <CRow>
                          <div
                            style="
                              text-align: center;
                              margin: 0 auto;
                              left: 0;
                              right: 0;
                              width: fit-content;
                            "
                          >
                            No upcoming class
                          </div>
                        </CRow>
                      </div>
                    </CCardBody>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>
           

            <CCard class="custom-bg-color-grey" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3 
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2" 
                  >
                    <strong> Test Exam Bank </strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 40px;">
                    Want to test your knowledge?
                  </label>
                  <CButton class="custom-header-btn ml-4" @click="GoToQuizAll()">Browse Quiz</CButton>
                                     
                </div>
                <div style="width: 50%" class="float-right">
                  <img style="
                    max-width: 100%;
                    right: 0px;
                    position: absolute;
                    bottom: 0px;
                    height: 150px;"
                    src="../../assets/img/icon/iconHoldpen.svg"
                  />
                </div>
              </CRow>
            </CCard> 

            
            
            

            <br /><br />
            <MainlayoutBottom class="d-md-none d-lg-none"></MainlayoutBottom>

          </div>
        </div>
      </div>
    </CContainer>


      </CCol>
      <CCol sm="3" class="p-0">
      <TheSidebarRight class="mt-3"></TheSidebarRight></CCol>
    </CRow>
    </div>

    <div class="c-app-new flex-row align-items-center d-md-none d-lg-none">
      <CRow class="p-0">
      <CContainer style="display: flex; justify-content: center" class="">
      <div class="container-box center">

        <div class="text-left">
          <div class="card-custom-web">
            <br />
            
            <CCard class="card-dark-orange">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3 class="label-dark-orange">
                    Your next class is at 9.00AM (Mathematics)
                  </h3>
                </div>
                <div style="width: 50%" class="float-right">
                  <img style="
                    position: absolute;
                    left: 73.13%;
                    right: 5.07%;
                    top: 3.57%;
                    bottom: 9.52%;"
                    src="../../assets/img/icon/bullseye.svg"
                  />
                </div>
              </CRow>
            </CCard>

            <br />

            <div class="float-left">
              <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name"> Myself / My Child </strong>
            </div>

            <br /><br />
            
            <!-- <div class="class-card-multiple" >
              <CCard class="card-rectangle" @click="GoToTimetable()" style="width: 25%; order: 0;">
                <img src="../../assets/img/icon/iconTimetable.svg" class="icon-reactangle" style="
                  width: 51px;
                  height: 43px;
                  left: calc(50% - 51px/2);
                  top: calc(50% - 43px/2 + 3px);" />
              </CCard>

              <CCard class="card-rectangle" style="width: 25%; order: 1;" @click="GoToQuiz()">
                <img src="../../assets/img/icon/iconQuiz.svg" class="icon-reactangle" style="
                  width: 23px;
                  height: 39px;
                  left: calc(50% - 23px/2 + 0.5px);
                  top: calc(50% - 39px/2 + 5px);" />
              </CCard>

              <CCard class="card-rectangle" style="width: 25%; order: 2;">
                <img src="../../assets/img/icon/iconExam.svg" class="icon-reactangle" style="
                  width: 29px;
                  height: 39px;
                  left: calc(50% - 29px/2 + 0.5px);
                  top: calc(50% - 39px/2 + 5px);" />
              </CCard>

              <CCard class=" card-rectangle" style="width: 25%; order: 3;">
                <img src="../../assets/img/icon/iconAskkiddo.svg" class="icon-reactangle" style="
                  justify-content: center; 
                  width: 41px;
                  height: 39px;
                  left: calc(50% - 41px/2 + 0.5px);
                  top: calc(50% - 39px/2 + 5px);" />
              </CCard>
            </div> -->

            <CRow class="justify-content-center mb-2">
              <CCol
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <CCol sm="12" lg="12">
                  <CCol
                    sm="12"
                    lg="12"
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      left: 0;
                      right: 0;
                      bottom: 0px;
                    "
                  >
                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToTimetable()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/calendar.svg" />
                          <br />
                          <label class="text-icon custom-font-cards">
                            Timetable</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" @click="GoToQuiz()">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/quiz.svg" />
                          <br />
                          <label class="text-icon custom-font-cards"> Quiz</label>
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0 mr-2" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1">
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/exam.svg" style="filter: grayscale(1);"/>
                          <br />
                          <label class="text-icon custom-font-cards">
                            Exam</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>

                    <CCol sm="3" lg="3" class="p-0" style="width: 25%">
                      <CCard style="border: none" class="text-center p-1" >
                        <CCol style="padding-left: 0px; padding-right: 0px;">
                          <img src="../../assets/img/icon/chat.svg" style="filter: grayscale(1);"/>
                          <br />
                          <label class="text-icon custom-font-cards">
                            Askkiddo</label
                          >
                        </CCol>
                      </CCard>
                    </CCol>
                  </CCol>
                </CCol>
              </CCol>
            </CRow>


            <br />
              <div class="float-left">
                <strong style="color: #000A2C; text-align: left; margin: 20px;" class="class-teach-name"> Upcoming Class</strong>
              </div>
              <div class="float-right">
                <strong class="custom-text-viewall" style="margin: 20px;" @click="GoToTimetable()">View All</strong>
              </div>
              <div style="clear: both"></div>
          
              <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="2"
                pagination="yes"
                class="d-sm-down-none"
              >
                <slide
                  v-for="slide in schedule"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3"
                  >
                    <CCardHeader>
                      <b>{{ slide.name }} Class</b>
                      <div class="card-header-actions">
                        <b> Today</b>
                      </div>
                    </CCardHeader>
                    <CCardBody class="overflow-auto" v-if="slide.studentSchedule.length">
                      <div v-if="slide.studentSchedule.length">
                        <CRow
                          v-for="slides in slide.studentSchedule"
                          v-bind:key="slides.id" class="ml-2 mr-2"
                        >
                          <div style="width: 50%" class="float-left">
                            {{ slides.subjectName }}
                          </div>
                          <div style="width: 50%" class="float-right">
                            {{ slides.start | moment("HH:mm A") }} -
                            {{ slides.end | moment("HH:mm A") }}
                          </div>
                        </CRow>
                      </div>
                      <div v-else>
                        <CRow>
                          <div
                            style="
                              text-align: center;
                              margin: 0 auto;
                              left: 0;
                              right: 0;
                              width: fit-content;
                            "
                          >
                            No upcoming class
                          </div>
                        </CRow>
                      </div>
                    </CCardBody>
                     <CCardBody class="overflow-auto" v-else>
                       <div>
                        <CRow>
                          <div
                            style="
                              text-align: center;
                              margin: 0 auto;
                              left: 0;
                              right: 0;
                              width: fit-content;
                            "
                          >
                            No upcoming class
                          </div>
                        </CRow>
                      </div>
                    </CCardBody>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>

            <div class="ml-3 mr-3 mb-3">
              <hooper
                settings="hooperSettings"
                ref="hooper"
                :itemsToShow="1"
                pagination="yes"
                class="d-sm-flex d-md-none"
              >
                <slide
                  v-for="slide in schedule"
                  :key="slide.Id"
                  :index="slide.Id"
                >
                  <CCard
                    style="border-radius: 10px; height: 200px"
                    class="overflow-auto"
                  >
                    <CCardHeader>
                      <b>{{ slide.name }} Class</b>
                      <div class="card-header-actions">
                        <b> Today</b>
                      </div>
                    </CCardHeader>
                    <CCardBody class="overflow-auto" v-if="slide.studentSchedule.length">
                      <div>
                        <CRow
                          v-for="slides in slide.studentSchedule"
                          v-bind:key="slides.id"
                          class="ml-2 mr-2"
                        >
                          <div style="width: 50%" class="float-left">
                            {{ slides.subjectName }}
                          </div>
                          <div style="width: 50%" class="float-right">
                            {{ slides.start | moment("HH:mm A") }} -
                            {{ slides.end | moment("HH:mm A") }}
                          </div>
                        </CRow>
                      </div>
                     
                    </CCardBody>
                    <CCardBody class="overflow-auto" v-else>
                       <div>
                        <CRow>
                          <div
                            style="
                              text-align: center;
                              margin: 0 auto;
                              left: 0;
                              right: 0;
                              width: fit-content;
                            "
                          >
                            No upcoming class
                          </div>
                        </CRow>
                      </div>
                    </CCardBody>
                  </CCard>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>
           

            <CCard class="custom-bg-color-grey" style="height: 153px">
              <CRow>
                <div style="width: 50%" class="float-left">
                  <h3 
                    style="text-align: left"
                    class="sub-title-header2 mt-1 ml-4 mb-2" 
                  >
                    <strong> Test Exam Bank </strong><br />
                  </h3>
                  <label class="sub-title-card2 ml-4" style="margin-bottom: 40px;">
                    Want to test your knowledge?
                  </label>
                  <CButton class="custom-header-btn ml-4" @click="GoToQuizAll()">Browse Quiz</CButton>
                                     
                </div>
                <div style="width: 50%" class="float-right">
                  <img style="
                    max-width: 100%;
                    right: 0px;
                    position: absolute;
                    bottom: 0px;
                    height: 150px;"
                    src="../../assets/img/icon/iconHoldpen.svg"
                  />
                </div>
              </CRow>
            </CCard> 

            
            
            

            <br /><br />
            <MainlayoutBottom></MainlayoutBottom>

          </div>
        </div>
      </div>
    </CContainer>

   
      <CCarousel
        arrows
        indicators
        animate
        height="100px"
        >
        <CCarouselItem>
          <span class="class-top-header top-header-badge">Best Match Quiz</span>
          <span class="class-top-header class-teach-name">Algebra and Calculus</span> 
          <span class="class-top-header class-teach-subject">Mathematics (Form 5)</span>
          <span class="float-right custom-bg-icon">
            <img src="../../assets/img/icon/Circle.svg" style="
            right: -6px;
            position: absolute;
            bottom: -135px;
            width: 160px;
            height: 160px;" />
            <img src="../../assets/img/icon/iconCalculator.svg" style="
            position: absolute;
            width: 70px;
            height: 70px;
            right: 20px;
            bottom: -95px;" />
          </span>
        </CCarouselItem>

        <CCarouselItem>
          <span class="class-top-header top-header-badge" style="width: 154px">Top Student of 5 Akas</span>
          <span class="class-top-header class-teach-name" style="width: 200px;">{{user.name}}</span> 
          <span class="class-top-header class-teach-subject">Mid Year Exam 2022 Mathematics</span>
          <span class="float-right custom-bg-icon">
            <img src="../../assets/img/icon/Circle.svg" style="
            right: -6px;
            position: absolute;
            bottom: -135px;
            width: 160px;
            height: 160px;" />
            <img src="../../assets/img/icon/userprofile.svg" style="
            position: absolute;
            width: 70px;
            height: 70px;
            right: 20px;
            bottom: -95px;" />
          </span>
        </CCarouselItem>
      </CCarousel>
      </CRow>
    </div>
          
    <div style="clear: both"></div>    
  </div>
</template>

<script>
import Vue from "vue";
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import MainlayoutBottom from "../../containers/TheBottomCustom2.vue";
import TheSidebar from "../../containers/TheCustomSidebar.vue";
import TheSidebarRight from "../../containers/TheCustomSidebarRight.vue";

Vue.use(require("vue-moment"));
import moment from "moment";

import "hooper/dist/hooper.css";
export default {
  name: 'Carousels',
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination,
    MainlayoutBottom,
    TheSidebar,
    TheSidebarRight
  },
  data: function () {
    return {
      user: {},
      studentProfileAuthorize: "",
      schedule: [],
      hooperSettings: {
        itemsToShow: 2,
        centerMode: true,
        breakpoints: {
          800: {
            centerMode: false,
          },
          1000: {
            pagination: "fraction",
          },
        },
      },
      childs: [],
      parent: [],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            // this.GetAuthorizeProfile(this.user.id);
            // this.GetListChild(this.user.id);
            this.GetScheduleToday(this.user.id);
          }
        });
    },

    GetScheduleToday() {
      this.$API
        .get(this.$SchedulesStudentsWebToday + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
          }
        });
    },
    GoToQuizAll()
    {
      this.$router.push("/ExamBank");
    },

    // GetListChild() {
    //   this.$API
    //     .get(this.$ListChild + "?userID=" + this.user.id, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.childs = response.data;
    //       }
    //     });
    // },



    GoToTimetable() {
      this.$router.push("/Class/ClassTimetable");
    },
    GoToQuiz()
    {
        this.$router.push("/Class/CategoryQuiz");
    }
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-top-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;  
  gap: 8px;

  position: absolute;
  width: 112px;  
  left: 17px;    
}

.top-header-badge {
  padding: 4px 1px;
  top: 14px;
  height: 23px;

  /* Pure/White */

  background: #FFFFFF;
  border-radius: 4px;

  /* width: 96px;
  height: 15px; */

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */


  /* Blue/Primary */

  color: #007CEF;


  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #FFFFFF;


  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}

.class-teach-subject {
  /* padding: 4px 1px; */
  top: 89px;
  height: 15px;
  width: auto;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */


  /* Pure/White */

  color: #FFFFFF;


  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}

.carousel2 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  position: absolute;
  width: 36px;
  height: 6px;
  left: 20px;
  top: 115px;
}

.card-dark-orange {
  /* width: 335px; */
height: 84px;

/* Brand/Gradient-Orange */

background: linear-gradient(286.01deg, #F5AF45 7.93%, #C96000 96.74%);
border-radius: 10px;
margin: 0px 20px;
display: flex;
justify-content: center;

/* Inside auto layout */

/* flex: none;
order: 0;
flex-grow: 0; */
}

.label-dark-orange {
  position: absolute;
width: 223px;
height: 44px;
left: 16px;
top: 20px;

/* Title/1/Semibold */

font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 22px;

/* Pure/White */

color: #FFFFFF;

}

.class-card-multiple {
 display: flex;
flex-direction: row;
justify-content: center;
align-items: flex-start;
padding: 0px;
gap: 16px;

/* width: 334px; */
height: 65px;
margin: 0px 20px;
display: flex;
justify-content: center;


/* Inside auto layout */

flex: none;
order: 1;
flex-grow: 0;
}

.card-rectangle {
/* width: 71px; */
height: 65px;
/* margin-left: 10px;
margin-right: 10px; */
/* display: flex; */
justify-content: center;

background: #FFFFFF;
/* Clickable/Light */

box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
border-radius: 8px;

/* Inside auto layout */

/* flex: none;
order: 0;
flex-grow: 0; */
}

.icon-reactangle {
    display: flex;
flex-direction: column;
align-items: center;
padding: 0px;
gap: 4px;
position: absolute;
}

.card-upcoming-class {
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
gap: 16px;

/* width: 335px; */
/* height: 184px; */
margin: 0px 20px;
display: flex;
justify-content: center;

/* Inside auto layout */

/* flex: none;
order: 2;
flex-grow: 0; */
}

.card-light-orange {
height: 117px;

/* Brand/Gradient-Yellow */

background: linear-gradient(100.86deg, #FFC123 10.53%, #FFE9B0 100.76%);
/* Clickable/Light */

box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
border-radius: 8px;
margin: 0px 20px;
display: flex;
justify-content: center;

/* Inside auto layout */

/* flex: none;
order: 3;
flex-grow: 0; */
}

.circle {
    vertical-align: top;
  position: absolute;
  top: 20px;
  text-align: right;
  float: none;
  left: 20px;
}

.custom-bg-icon {
    vertical-align: top;
  position: absolute;
  top: 10px;
  text-align: center;
  margin: 20px auto;
  float: none;
  left: 0;
  right: 0;
}

.icon-calc {
    position: absolute;
width: 107px;
height: 107px;
left: 249px;
/* top: 62px; */

border-radius: 107px;
}

.carousel {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    padding: 0px;
    gap: 4px;
    position: absolute;
    width: 100%;
    height: 6px;
    left: 0px; 
    top: 30px;
}


.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 15;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: left;  
    margin-right: 15%;
    margin-left: 5%;  
    list-style: none; 
    margin-bottom: -20px;  
}

.carousel-indicators li {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: 5px;  
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    -webkit-transition: opacity 0.6s ease;
    transition: opacity 0.6s ease;
}



.carousel-inner {
  position: relative;
  width: 100%;
  overflow: visible;
  top: -30px;
}

.custom-font-cards {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
}
</style>
